<template>
  <div id="administrador">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <HeaderAdmin></HeaderAdmin>

    <div class="pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <!-- <b-sidebar id="sidebar-1" title="Menú" shadow>
        <div class="px-3 py-2">
          <a class="float-right fpR pointer" @click="logout"> Cerrar Sesión </a>
        </div>
      </b-sidebar> -->

      <div class="row m-0">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <SidebarAdmin></SidebarAdmin>
            </div>
          </div>
        </div>

        <div class="col-9 bgazuladmin bgazulgradiente p-5">
          <div class="row p-5" data-aos="fade-left" data-aos-delay="200">
            <div class="col-12 pb-5">
              <form action="" class="formadmin blanco fpXG2" v-if="userProfile.user_id != 'rcThpvogSRce5y5FkTWAmNjnjYv1'">
                <label>
                  <span>Experiencias Disponibles</span>
                  <input
                    type="text"
                    v-model="disponibles"
                    readonly
                  />
                </label>
                <!-- <label>
                  <span>Asignadas</span>
                  <input type="email" v-model="form.asignadas" readonly />
                </label> -->
                <!-- <label>
                  <span>Completadas</span>
                  <input type="password" v-model="form.completadas" readonly />
                </label> -->
              </form>
              <form action="" class="formadmin blanco fpXG2" @submit="agregaExperiencias($event)" v-else>
                <label>
                  <span>Experiencias Disponibles</span>
                  <input
                    type="text"
                    v-model="disponibles"
                  />
                </label>
                <label class="float-left">
                  <button type="submit" class="mr-4">Establecer número de experiencias disponibles</button>
                </label>
                <!-- <label>
                  <span>Asignadas</span>
                  <input type="email" v-model="form.asignadas" readonly />
                </label> -->
                <!-- <label>
                  <span>Completadas</span>
                  <input type="password" v-model="form.completadas" readonly />
                </label> -->
              </form>
            </div>
            <!-- <div class="col-12 pb-5">
              <form
                action=""
                class="formadmin blanco fpXG2"
                @submit="submitForm($event)"
              >
                <label>
                  <span>Cargar Experiencias</span>
                  <a
                    href="https://encaucetotal.com/"
                    target="_blank"
                    class="button"
                  >
                    COMPRAR
                  </a>
                </label>
              </form>
            </div> -->

            <div class="col-12 pb-5">
              <h2 class="blanco bold pb-3">Datos de Facturación</h2>
              <form
                action=""
                class="formadmin blanco fpXG2"
                @submit="submitFacturacion($event)"
              >
                <label>
                  <span>RFC/Razón Social</span>
                  <input type="text" v-model="formFacturacion.rfc" required />
                </label>
                <label>
                  <span>Nombre Completo</span>
                  <input
                    type="text"
                    v-model="formFacturacion.nombre"
                    required
                  />
                </label>
                <label>
                  <span>Correo</span>
                  <input
                    type="email"
                    v-model="formFacturacion.email"
                    required
                  />
                </label>
                <label>
                  <span>Teléfono</span>
                  <input
                    type="tel"
                    v-model="formFacturacion.telefono"
                    maxlength="10"
                    required
                  />
                </label>
                <label>
                  <span>Dirección</span>
                  <input
                    type="text"
                    v-model="formFacturacion.direccion"
                    required
                  />
                </label>
                <label class="text-right py-5">
                  <button type="submit">ACTUALIZAR</button>
                </label>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SidebarAdmin from "@/components/SidebarAdmin";
import HeaderAdmin from "@/components/HeaderAdmin";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    SidebarAdmin,
    HeaderAdmin,
    Glyphicons,
  },
  data() {
    return {
      form: {
        nombre_administrador: "",
        email: "",
        password: "",
        password2: "",
      },
      formCargar: {
        file: "",
      },
      formFacturacion: {
        rfc: "",
        nombre: "",
        email: "",
        telefono: "",
        direccion: "",
      },
      initiated: false,
      disponibles: ""
    };
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
    institucionID(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.init();
  },
  methods: {
    async init() {

      if (this.userProfile == null || this.institucionID == null || this.initiated == true) {
        return;
      }

      this.disponibles = this.userProfile.disponibles;

      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        this.disponibles = await this.$store.dispatch("getDisponibles", this.userProfile.institucion); 
      }

      console.log("iniciando exp");

      this.initiated = true;

      //////////////////////////


      this.camposObj = this.$store.state.campos_conocimiento;

      if (this.userProfile.facturacion != undefined) {
        this.formFacturacion = {
          rfc: this.userProfile.facturacion.rfc,
          nombre: this.userProfile.facturacion.nombre,
          email: this.userProfile.facturacion.email,
          telefono: this.userProfile.facturacion.telefono,
          direccion: this.userProfile.facturacion.direccion,
        };
      }
    },
    async agregaExperiencias(e){
      e.preventDefault();

      if(this.disponibles <= 0){
        swal.fire(
          "Oops",
          "El número de experiencias debe de ser mayor a 0.",
          "warning"
        );
        return;
      }
      let res = await this.$store.dispatch("agregaExperiencias", {institucion: this.userProfile.institucion, disponibles: this.disponibles});

      if(res === true){
        swal.fire(
          "Bien",
          "El número de experiencias se ha actualizado.",
          "success"
        );
      }else{
        swal.fire(
          "Oops",
          "Hubo un problema, por favor intenta de nuevo.",
          "warning"
        );
      }

    },
    submitForm(e) {
      e.preventDefault();

      this.$store.dispatch("setDatosAdministrador", this.form);
    },
    submitFacturacion(e) {
      e.preventDefault();

      let institucion = {
        institucion_id: this.institucionID,
        ecommerce_user_id: this.userProfile.ecommerce_user_id,
        nombre: this.userProfile.nombre,
        disponibles: this.userProfile.disponibles,
      };
      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        institucion.institucion_id = this.userProfile.institucion; 
      }

      this.$store.dispatch("setFacturacion", this.formFacturacion);
    },
    logout() {
      this.$store.dispatch("logoutReportes");
    },
  },
};
</script>
